import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<>"')\]]+)/g;

const MessageContent = ({ text, style = {} }) => {
  if (!text) return null;

  const parts = text.split(URL_REGEX);

  return (
    <div
      data-testid="message-content"
      style={{
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        userSelect: 'text',
        WebkitUserSelect: 'text',
        ...style
      }}
    >
      {parts.map((part, i) =>
        URL_REGEX.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`message-link-${i}`}
            style={{
              color: '#93c5fd',
              textDecoration: 'underline',
              wordBreak: 'break-all'
            }}
            onClick={e => e.stopPropagation()}
          >
            {part}
          </a>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </div>
  );
};

export default MessageContent;
